import {getLayerByName, updateLayerStyle} from "@/helpers/ol/ol-layer-helper";
import {getDrawModify, updateDrawStyle} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {Fill, RegularShape, Stroke, Style, Text} from "ol/style";
import {hexToRgba} from "@/helpers/color-helper";
import CircleStyle from "ol/style/Circle";
import {LineString, Point} from "ol/geom";
import {getArea, getLength} from "ol/sphere";
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {initPopper} from "@/modules/popper";
import {Feature} from "ol";
import {deselectFeature, selectFeature} from "@/modules/ol/service/ol-service-wfs";
import hi from "datatables.net-plugins/i18n/hi.mjs";
import {getDefaultStyle} from "ol/format/KML";
import {getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper.js";
import $ from "jquery";

let style = {}
style.strokeColor = '#3085b5'
style.strokeOpacity = '1.00'
style.fillColor = '#3085b5'
style.fillOpacity = '0.20'
style.strokeWidth = 4

style.fontColor = '#000000'
style.segmentFontColor = '#000000'
style.fontOpacity = 0
style.fontSize = 45
style.fontFamily = 'Arial'
style.labelOutlineColor = '#ffffff'
style.labelOutlineOpacity = 0
style.labelOutlineWidth = 0

let textPadding = [4,4,4,4]

let areSegmentsVisible = true
let activeMeasureFeatureKey = 0

export function setActiveMeasureFeatureKey(key) {
    activeMeasureFeatureKey = key
}

export function getToolsMeasureStyle() {
    return style
}

export function getAreSegmentsVisible() {
    return areSegmentsVisible
}

export function setMeasureStyleValue(name, value) {
    style[name] = value

    segmentStyles.map(segmentStyle => {
        segmentStyle.getText().getFill().setColor('rgba(' + hexToRgba(style.segmentFontColor, style.fontOpacity)+ ')')
        segmentStyle.getText().getBackgroundFill().setColor('rgba(' + hexToRgba(style.labelOutlineColor, style.labelOutlineOpacity)+ ')')
        segmentStyle.getText().getBackgroundStroke().setColor('rgba(' + hexToRgba(style.segmentFontColor, style.fontOpacity)+ ')')

        // segmentStyle.getImage().getFill().setColor('rgba(' + hexToRgba(style.labelOutlineColor, style.labelOutlineOpacity)+ ')')
    })

    labelStyle.getText().getFill().setColor('rgba(' + hexToRgba(style.segmentFontColor, style.fontOpacity)+ ')')
    labelStyle.getText().getBackgroundFill().setColor('rgba(' + hexToRgba(style.labelOutlineColor, style.labelOutlineOpacity)+ ')')
    labelStyle.getText().getBackgroundStroke().setColor('rgba(' + hexToRgba(style.segmentFontColor, style.fontOpacity)+ ')')

    const element = document.querySelector('#divMeasureDrawings .media.active')
    if(element) {
        const key = element.dataset.featureKey
        const feature = window.drawMeasureVectorSource.getFeatures()[key]
        // console.log(feature)
        feature.set('style', {...style})
        feature.set('key', key)

        generateMeasureLayers(true)
    }
}

const measureLayerName = 'draw-measure'
export function geMeasureLayerName() {
    return measureLayerName
}

export function updateMeasureLayerStyle() {
    updateLayerStyle(geMeasureLayerName(), (feature) => {
        return getMeasureLayerStyleFunction(feature, true);
    })
    updateDrawStyle((feature) => {
        return getMeasureLayerStyleFunction(feature, true);
    })
}

export function geMeasureLayerStyle(feature, select = false) {

    let measureStyle = style
    let text = ''
    if(feature && feature.get('style')) {
        measureStyle = feature.get('style')
        text = feature.get('text')
        if(text) {
            measureStyle.strokeWidth = 0
        }
    }

    // if(select) {
    //     const defaultStyle = window.settings.wfsStyle
    //     // measureStyle.fillColor = defaultStyle.SelectFillColor
    //     // measureStyle.strokeColor = defaultStyle.SelectStrokeColor
    //     // measureStyle.strokeWidth = defaultStyle.SelectStrokeWidth
    //
    //     return new Style({
    //         image: new CircleStyle({
    //             radius: measureStyle.strokeWidth,
    //             fill: new Fill({
    //                 color: 'rgba(' + hexToRgba(defaultStyle.SelectFillColor, measureStyle.fillOpacity)+ ')'
    //             }),
    //             stroke: new Stroke({
    //                 color: 'rgba(' + hexToRgba(measureStyle.SelectFillColor, measureStyle.strokeOpacity) + ')',
    //                 width: measureStyle.strokeWidth
    //             }),
    //         }),
    //         fill: new Fill({
    //             color: 'rgba(' + hexToRgba(defaultStyle.SelectFillColor, measureStyle.fillOpacity) + ')'
    //         }),
    //         stroke: new Stroke({
    //             color: 'rgba(' + hexToRgba(defaultStyle.SelectFillColor, measureStyle.strokeOpacity) + ')',
    //             width: defaultStyle.strokeWidth
    //         }),
    //         text: new Text({
    //             text: text,
    //             font: measureStyle.fontSize + 'px ' + measureStyle.fontFamily,
    //             fill: new Fill({
    //                 color: measureStyle.fontColor,
    //             })
    //         }),
    //     })
    // }

    return new Style({
        image: new CircleStyle({
            radius: measureStyle.strokeWidth,
            fill: new Fill({
                color: 'rgba(' + hexToRgba(measureStyle.fillColor, measureStyle.fillOpacity)+ ')'
            }),
            stroke: new Stroke({
                color: 'rgba(' + hexToRgba(measureStyle.strokeColor, measureStyle.strokeOpacity) + ')',
                width: measureStyle.strokeWidth
            }),
        }),
        fill: new Fill({
            color: 'rgba(' + hexToRgba(measureStyle.fillColor, measureStyle.fillOpacity) + ')'
        }),
        stroke: new Stroke({
            color: 'rgba(' + hexToRgba(measureStyle.strokeColor, measureStyle.strokeOpacity) + ')',
            width: measureStyle.strokeWidth
        }),
        text: new Text({
            text: text,
            font: measureStyle.fontSize + 'px ' + measureStyle.fontFamily,
            fill: new Fill({
                color: measureStyle.fontColor,
            })
        }),
    })
}

const labelStyle = new Style({
    text: new Text({
        font: '14px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(' + hexToRgba(style.fontColor, style.fontOpacity)+ ')'
        }),
        backgroundFill: new Fill({
            color: 'rgba(' + hexToRgba(style.labelOutlineColor, style.labelOutlineOpacity)+ ')',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(0,0,0,' + style.fontOpacity + ')',
            width: 1
        }),
        padding: textPadding,
        offsetX: 45,
        offsetY: -15
    }),
});

const tipStyle = new Style({
    text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(' + hexToRgba(style.fontColor, 0.8)+ ')'
        }),
        backgroundFill: new Fill({
            color: 'rgba(' + hexToRgba(style.labelOutlineColor, 0.8)+ ')',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(0,0,0,' + style.fontOpacity + ')',
            width: 1
        }),
        padding: textPadding,
        textAlign: 'left',
        offsetX: 15,
        offsetY: 15
    }),
});

const segmentStyle = new Style({
    text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({
            color: 'rgba(' + hexToRgba(style.fontColor, style.fontOpacity)+ ')'
        }),
        backgroundFill: new Fill({
            color: 'rgba(' + hexToRgba(style.labelOutlineColor, style.labelOutlineOpacity)+ ')',
        }),
        backgroundStroke: new Stroke({
            color: 'rgba(0,0,0,' + style.fontOpacity + ')',
            width: 1
        }),
        padding: textPadding,
        image: new RegularShape({
            radius: 18,
            points: 3,
            angle: Math.PI,
            displacement: [0, 10],
            fill: new Fill({
                color: 'rgba(0, 0, 0, 0.7)',
            }),
        }),
    })
});

const segmentStyles = [segmentStyle];
// const modify = new Modify({source: source, style: modifyStyle});
let tipPoint;

export function getMeasureModifyStyle() {
    return new Style({
        image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.7)',
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 0, 0.4)',
            }),
        }),
        text: new Text({
            text: 'Trek aan lijn om te bewerken',
            font: '12px Calibri,sans-serif',
            fill: new Fill({
                color: 'rgba(' + hexToRgba(style.fontColor, 0.8)+ ')'
            }),
            backgroundFill: new Fill({
                color: 'rgba(' + hexToRgba(style.labelOutlineColor, 0.8)+ ')',
            }),
            padding: textPadding,
            textAlign: 'left',
            offsetX: 15,
        }),
    });
}

export function getMeasureLayerStyleFunction(feature, segments, drawType, tip, styles = undefined) {

    // console.log(feature.getId())


    if(styles === undefined) {
        styles = [geMeasureLayerStyle(feature)];
    }

    const geometry = feature.getGeometry();
    const type = geometry.getType();


    if(drawType === 'Point') {
        tip = 'Klik in de kaart om de tekst de plaatsen'
    }

    let point, label, line;

    let key = feature.get('key')

    if(key === undefined) {
        key = feature.getId()
    }

    if(key !== undefined && isNaN(parseInt(key))) {
        key = 100000
        // key = 100000 + key.split('.')[1]
    }

    if(key !== undefined) {
        // window.measurePrintFeatures = []
        window.measurePrintFeatures[key] = []
    }

    if (!drawType || drawType === type) {



        if (type === 'Polygon') {
            point = geometry.getInteriorPoint();
            label = formatArea(geometry);
            line = new LineString(geometry.getCoordinates()[0]);

            let totalSegments = 0
            line.forEachSegment(() => {
                totalSegments++
            })

            // Hide total
            if(totalSegments < 3) {
                label = ''
            }

        } else if (type === 'LineString') {
            point = new Point(geometry.getLastCoordinate());
            label = formatLength(geometry);
            line = geometry;
        } else if(type === 'Circle') {
            point = new Point(geometry.getCenter());
            label = 'Straal: ' + geometry.getRadius().toFixed(2) + ' m';
        }

        const feature = new Feature({
            geometry: point
        })
        feature.set('text', label)

        if(key !== undefined) {
            // window.measureFeatures[key].push(feature)
            window.measurePrintFeatures[key].push(feature)
        }
    }


    if (segments && line) {

        let count = 0;
        line.forEachSegment(function (a, b) {
            const segment = new LineString([a, b]);
            const label = formatLength(segment);
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(segmentStyle.clone());
                // segmentStyles.push(segmentStyle.clone());
            }
            const segmentPoint = new Point(segment.getCoordinateAt(0.5));
            segmentStyles[count].setGeometry(segmentPoint);
            segmentStyles[count].getText().setText(label);
            styles.push(segmentStyles[count]);

            const feature = new Feature({
                geometry: segmentPoint
            })
            feature.set('text', label)
            if(key !== undefined) {
                // window.measureFeatures[key].push(feature)
                window.measurePrintFeatures[key].push(feature)
            }
            count++;
        });
    }
    if (label) {
        labelStyle.setGeometry(point);
        labelStyle.getText().setText(label);
        styles.push(labelStyle);
    }
    if (
        tip &&
        type === 'Point'
        && !getDrawModify().getOverlay().getSource().getFeatures().length
    ) {
        tipPoint = geometry;
        tipStyle.getText().setText(tip);
        styles.push(tipStyle);
    }
    return styles;
}

const formatLength = function (line) {
    const length = getLength(line);
    let output;

    if(getBySelector('#slcSegmentsMeasureType').value === 'm') {
        output = Math.round(length * 100) / 100 + ' m';
    }
    if(getBySelector('#slcSegmentsMeasureType').value === 'km') {
        output = Math.round((length / 1000) * 100) / 100 + ' km';
    }

    return output;
};

const formatArea = function (polygon) {
    const area = getArea(polygon);
    let output;

    if(getBySelector('#slcSegmentsMeasureType').value === 'm') {
        output = Math.round(area * 100) / 100 + ' m\xB2';
    }
    if(getBySelector('#slcSegmentsMeasureType').value === 'km') {
        output = Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    }

    return output;
};

export function unCheckDrawButtons() {
    getBySelector('layer-info-tools-measure-template').querySelectorAll('input').forEach(element => {
        element.checked = false
    })
}

export function generateMeasureLayers(deselect = false, featureIndex = undefined) {
    setTimeout(() => {
        getBySelector('#divMeasureDrawings').innerHTML = ''
        const features = window.drawMeasureVectorSource.getFeatures()
        features.map((feature, key) => {
            generateMeasureLayer(feature, key, activeMeasureFeatureKey)
        })
        if(featureIndex || featureIndex === 0) {
            const feature = window.drawMeasureVectorSource.getFeatures()[featureIndex]
            // selectFeature(feature, 'draw')
        }
        if(deselect) {
            deselectFeature()
        }
    })
}

function generateMeasureLayer(feature, key, activeFeatureKey) {

    const featureStyle = feature.get('style')

    let text = ''
    let icon = ''
    let value = ''
    let htmlStyle = ''
    const geometry = feature.getGeometry()
    switch (geometry.getType()) {
        case 'Polygon':
            htmlStyle = `color: rgba(${hexToRgba(featureStyle.fillColor, featureStyle.fillOpacity)});border: ${featureStyle.strokeWidth}px solid rgba(${hexToRgba(featureStyle.strokeColor, featureStyle.strokeOpacity)});`
            icon = 'fa fa-square'
            text = 'Oppervlakte'
            value = formatArea(geometry)
            break;
        case 'Point':
            htmlStyle = `color: rgba(${hexToRgba(featureStyle.fillColor, featureStyle.fillOpacity)});border: ${featureStyle.strokeWidth}px solid rgba(${hexToRgba(featureStyle.strokeColor, featureStyle.strokeOpacity)});`

            if(feature.getProperties().text) {
                icon = 'fa fa-font'
                text = `Tekst`
                value = feature.getProperties().text
            } else {
                icon = 'far fa-dot-circle'
                text = `Punt`
            }

            break;
        case 'LineString':
            htmlStyle = `color: rgba(${hexToRgba(featureStyle.strokeColor, featureStyle.strokeOpacity)});border: 0px solid transparent;`

            icon = 'fa fa-slash'
            text = 'Lengte'
            value = formatLength(geometry)
            break;
        default:
            htmlStyle = `color: rgba(${hexToRgba(featureStyle.fillColor, featureStyle.fillOpacity)});border: ${featureStyle.strokeWidth}px solid rgba(${hexToRgba(featureStyle.strokeColor, featureStyle.strokeOpacity)});border-radius:100%`
            value = 'Straal: ' + geometry.getRadius().toFixed(2) + ' m'
            icon = 'fa fa-circle'
            text = 'Cirkel'
            break;
    }

    let active = ''
    if(key === activeFeatureKey) {
        active = 'active'
    }

    const innerHTML = `
    <a href="javascript:void(0)" data-feature-key="${key}" class="media align-items-center bg-lighter text-secondary pt-2 pb-2 px-4 ${active}">
        <div class="${icon} fa-border" style="${htmlStyle}"></div>
        <div class="media-body ml-3">
          ${text} 
          <span class="float-right">
                 ${value}
                 <button 
                    data-type="info"
                    title="Bekijk informatie" 
                    class="btn btn-sm borderless icon-btn ml-1">
                    <span data-type="info" class="fa fa-info"></span>
                </button>
                 <button 
                    data-type="expand"
                    title="Inzoomen op tekening" 
                    class="btn btn-sm borderless icon-btn ml-1">
                    <span data-type="expand" class="fa fa-expand"></span>
                </button>
                 <button 
                    data-type="remove"
                    title="Verwijder tekening" 
                    class="btn btn-sm borderless icon-btn ml-1">
                    <span data-type="remove" class="fa fa-times text-danger"></span>
                </button>
            </span>
        </div>
    </a>
    <hr class="m-0"/>
`
    getBySelector('#divMeasureDrawings').innerHTML += innerHTML

    initPopper()
}

export function toggleSegmentStyle() {
    areSegmentsVisible = !areSegmentsVisible
    setSegmentStyleVisible(areSegmentsVisible)
}

export function setSegmentStyleVisible(areSegmentsVisible) {
    let opacity = 0
    if(areSegmentsVisible) {
        opacity = 0.8

        showElementsBySelector('#divPrintSegments')
    } else {
        hideElementsBySelector('#divPrintSegments')
    }
    setMeasureStyleValue('fontOpacity', opacity)
    setMeasureStyleValue('labelOutlineOpacity', opacity)
    updateMeasureLayerStyle()
}

export function getMeasureFeatures() {
    return window.measureFeatures
}

export function setActiveMeasureFeature(element, highLight = false) {
    removeClassBySelector('#divMeasureDrawings .media', 'active')
    element.classList.add('active')
    const feature = window.drawMeasureVectorSource.getFeatures()[element.dataset.featureKey]
    const featureStyle = feature.get('style')

    if(feature.get('text')) {
        hideElementsBySelector('#divDrawFigure')
        showElementsBySelector('#divDrawText')
    } else {
        hideElementsBySelector('#divDrawText')
        showElementsBySelector('#divDrawFigure')
    }

    if(highLight) {
        setTimeout(() => {
            selectFeature(feature, 'select')
        }, 300)
    }

    $('#iptToolsFillColor').minicolors('value', featureStyle.fillColor);
    $('#iptToolsFillColor').minicolors('opacity', featureStyle.fillOpacity);

    $('#iptToolsStrokeColor').minicolors('value', featureStyle.strokeColor);
    $('#iptToolsStrokeColor').minicolors('opacity', featureStyle.strokeOpacity);

    $('#iptToolsStrokeWidth').val(featureStyle.strokeWidth);
    setActiveMeasureFeatureKey(parseInt(element.dataset.featureKey))
}
